export const renderBoolean = (val?: boolean): React.ReactNode =>
  val === true ? 'Yes' : 'No';

export const renderStringArrayValue = (val?: string[]): React.ReactNode => {
  return val && val.length > 0 ? val.join(', ') : null;
};
